/*
 * @Author: your name
 * @Date: 2021-04-21 14:28:28
 * @LastEditTime: 2021-04-28 15:15:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloud_app\src\common\components\Message.js
 */
import { Message } from "element-ui";
import { Toast } from "vant";
import { isMobile } from "utils/utils";

const factory = (type, options) => {
  const isMobilePhone = isMobile();
  if (isMobilePhone) {
    switch (type) {
      case "error":
        Toast.fail(options);
        break;
      case "success":
        Toast.success(options);
        break;
      case "warning":
        Toast(options);
        break;
      case "loading":
        Toast.loading(options);
        break;
      default:
        Toast(options);
    }
  } else {
    switch (type) {
      case "error":
        Message.error(options);
        break;
      case "success":
        Message.success(options);
        break;
      case "warning":
        Message.warning(options);
        break;
      default:
        Message.warning(options);
    }
  }
};

function message(options) {
  const isMobilePhone = isMobile();
  if (isMobilePhone) Toast(options);
  if (!isMobilePhone) Message(options);
}

message.error = options => factory("error", options);

message.success = options => factory("success", options);

message.warning = options => factory("warning", options);

message.loading = options => factory("loading", options);

export default message;
